import { RouteItem } from '@eastcoal/router/types/route'

import {
  AUDIT_PERSON_CREATE_PAGE_PATH,
  AUDIT_PERSON_DETAIL_PAGE_PATH,
  AUDIT_PERSON_EDIT_PAGE_PATH,
  AUDIT_PERSON_RESULT_PAGE_PATH
} from './constants/path'

export const personAuditRoute: RouteItem = {
  title: '个人认证',
  hideInMenu: true,
  children: [
    {
      title: '新增个人认证',
      path: AUDIT_PERSON_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    },
    {
      title: '编辑个人认证',
      path: AUDIT_PERSON_EDIT_PAGE_PATH,
      Component: () => import('./Edit')
    },
    {
      title: '个人认证详情',
      path: AUDIT_PERSON_DETAIL_PAGE_PATH,
      Component: () => import('./Detail')
    },
    {
      path: AUDIT_PERSON_RESULT_PAGE_PATH,
      Component: () => import('./Result')
    }
  ]
}
